// eslint-disable-next-line no-unused-vars
import * as React from "react";
import styled from "@emotion/styled";

export const MessageContentContainer = styled.div`
    pre {
        padding: 9.5px;
        margin: 0 0 10px;
        line-height: 1.42857143;
        word-break: break-all;
        word-wrap: break-word;
        background-color: #f5f5f5;
        border: 1px solid #ccc;
        border-radius: 4px;
    }
`;
